import React, {
  ParamHTMLAttributes,
} from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import NumberTextField from 'core/components/NumberTextField';

export type ACHFieldProps = {
  id: string;
  name: string;
  label: string;
  isRequired?: boolean;
};
export default function ACHPaymentField({
  id,
  label,
  className,
  isRequired = false,
  ...props
}: ACHFieldProps & Pick<ParamHTMLAttributes<HTMLElement>, 'className'>) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      rules={{ required: isRequired }}
      {...props}
      render={
        ({ field }) => (
          <Wrapper
            className={className}
            label={label}
            id={id}
            required={isRequired}
          >
            <NumberTextField {...field} />
          </Wrapper>
        )
      }
    />
  );
}
